import { StyleSheet, View } from "react-native";

import { AppText, Button, ButtonText, Stack, TextField } from "~/components/ui";
import { spacing } from "~/styles/theme";
import type { RecurringLineItemForm } from "./invoice-utils";

export function RecurringLineItemEditor({
  items,
  onAdd,
  onChange,
  onRemove,
}: {
  items: RecurringLineItemForm[];
  onAdd: () => void;
  onChange: (
    index: number,
    field: keyof RecurringLineItemForm,
    value: string,
  ) => void;
  onRemove: (index: number) => void;
}) {
  return (
    <Stack gap="sm">
      {items.map((item, index) => (
        <View key={`recurring-line-${index}`} style={styles.editPanel}>
          <View style={styles.formGrid}>
            <View style={[styles.field, styles.wideField]}>
              <AppText size="xs" weight="semibold">
                Line description
              </AppText>
              <TextField
                accessibilityLabel="Line description"
                value={item.description}
                placeholder="Monthly retainer"
                onChangeText={(value) => onChange(index, "description", value)}
              />
            </View>
            <View style={styles.smallField}>
              <AppText size="xs" weight="semibold">
                Qty
              </AppText>
              <TextField
                accessibilityLabel="Line qty"
                value={item.quantity}
                keyboardType="numeric"
                placeholder="1"
                onChangeText={(value) => onChange(index, "quantity", value)}
              />
            </View>
            <View style={styles.smallField}>
              <AppText size="xs" weight="semibold">
                Rate
              </AppText>
              <TextField
                accessibilityLabel="Line rate"
                value={item.unitAmount}
                keyboardType="numeric"
                placeholder="1200"
                onChangeText={(value) => onChange(index, "unitAmount", value)}
              />
            </View>
            <View style={styles.smallField}>
              <AppText size="xs" weight="semibold">
                GST %
              </AppText>
              <TextField
                accessibilityLabel="Line GST %"
                value={item.gstRate}
                keyboardType="numeric"
                placeholder="15"
                onChangeText={(value) => onChange(index, "gstRate", value)}
              />
            </View>
          </View>
          <Button
            align="start"
            compact
            variant="outline"
            iconName="trash-2"
            onPress={() => onRemove(index)}
          >
            <ButtonText>Remove line</ButtonText>
          </Button>
        </View>
      ))}
      <Button
        align="start"
        compact
        variant="outline"
        iconName="plus"
        onPress={onAdd}
      >
        <ButtonText>Add line item</ButtonText>
      </Button>
    </Stack>
  );
}

const styles = StyleSheet.create({
  editPanel: { gap: spacing.m },
  formGrid: { flexDirection: "row", flexWrap: "wrap", gap: spacing.m },
  field: { flex: 1, minWidth: 220, gap: spacing.xs },
  wideField: { flexBasis: 320 },
  smallField: { width: 120, gap: spacing.xs },
});
